import React from 'react';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import Store from 'store/store';
import Tables from 'components/Table';
import { formatValue } from 'components/IPS/PastPerformanceTable/utils';
import { makeStyles } from '@material-ui/core';
import {
  benchmarkFilter,
  formatName
} from 'components/Charts/Utils/benchmarks';
import { MetaType } from 'store/modules/Meta/types';

const { Table, TableRow, TableHead, TableCell } = Tables;

const { selectors } = Store;

interface MaxDrawdowmTableProps {
  existingOnly?: boolean;
  existingPoliciesPerformance: any;
  totalPerformanceData: any;
  benchmarks?: Array<MetaType>;
}

const useStyles = makeStyles(theme => ({
  row: {
    '&:nth-child(even):not(.MuiTableRow-head)': {
      backgroundColor: '#f7f7f7'
    }
  },
  benchmarkRow: {
    color: theme.palette.primary.main
  }
}));

const MaxDrawdowmTable = ({
  existingOnly = false,
  existingPoliciesPerformance,
  totalPerformanceData,
  benchmarks
}: MaxDrawdowmTableProps) => {
  const classes = useStyles();
  const dataToRender = () => {
    if (existingOnly) {
      return existingPoliciesPerformance;
    }

    return totalPerformanceData;
  };

  return (
    <>
      <Table>
        <TableHead cells={['', '1y', '3y', '5y']} />
        {dataToRender().map((fund: any, index: number) => {
          const isBenchmark = benchmarkFilter(
            benchmarks?.map((benchmark: any) => benchmark.name),
            fund.name
          );
          return (
            <TableRow
              className={`${classes.row} ${isBenchmark ? classes.benchmarkRow : ''}`}
              key={index}
            >
              <TableCell style={{ fontWeight: 700 }}>
                {formatName(fund.name)}
              </TableCell>
              <TableCell>{formatValue(fund.maximum_one_y_drawdown)}</TableCell>
              <TableCell>
                {formatValue(fund.maximum_three_y_drawdown)}
              </TableCell>
              <TableCell>{formatValue(fund.maximum_five_y_drawdown)}</TableCell>
            </TableRow>
          );
        })}
      </Table>
    </>
  );
};

export default compose(
  connect((state: any) => ({
    existingPoliciesPerformance:
      selectors.caseSelectors.existingPoliciesPerformance(state),
    totalPerformanceData: selectors.caseSelectors.totalPerformanceData(state)
  }))
)(MaxDrawdowmTable);
